var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 630.398 512",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565.6 127.6c.4 5.599.4 11.2.4 16.8C566 315.199 436.001 512 198.4 512 125.2 512 57.2 490.799 0 454.001c10.4 1.199 20.399 1.599 31.2 1.599 60.399 0 116-20.399 160.4-55.199C134.8 399.2 87.2 362 70.799 310.8c8.001 1.199 16.001 1.999 24.401 1.999 11.6 0 23.201-1.6 34-4.399-59.2-12.001-103.601-64-103.601-126.8V180c17.199 9.6 37.201 15.6 58.399 16.399-34.8-23.2-57.599-62.8-57.599-107.6 0-23.999 6.399-45.999 17.6-65.2 63.6 78.4 159.201 129.599 266.4 135.2-2-9.6-3.2-19.599-3.2-29.599 0-71.201 57.6-129.2 129.2-129.2 37.199 0 70.799 15.6 94.4 40.8 29.199-5.6 57.199-16.4 82-31.2-9.601 30.001-30.001 55.201-56.8 71.2 26-2.799 51.2-10.001 74.399-20-17.597 25.599-39.598 48.398-64.798 66.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default ForwardRef;